import { useEffect, useState } from "preact/hooks";
import {
  applyTheme,
  saveTheme,
  storedTheme,
  systemThemeQuery,
  type ThemePreference,
} from "../lib/theme.js";

const themes: Array<{ label: string; value: ThemePreference }> = [
  { label: "Use light theme", value: "light" },
  { label: "Use system theme", value: "auto" },
  { label: "Use dark theme", value: "dark" },
];

function ThemeIcon({ theme }: { theme: ThemePreference }) {
  if (theme === "light") {
    return (
      <svg viewBox="0 0 20 20" aria-hidden="true">
        <circle cx="10" cy="10" r="3.25" />
        <path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.35 4.35l1.4 1.4M14.25 14.25l1.4 1.4M15.65 4.35l-1.4 1.4M5.75 14.25l-1.4 1.4" />
      </svg>
    );
  }
  if (theme === "dark") {
    return (
      <svg viewBox="0 0 20 20" aria-hidden="true">
        <path d="M16.7 12.6A7 7 0 0 1 7.4 3.3 7 7 0 1 0 16.7 12.6Z" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <rect x="2.5" y="3.5" width="15" height="11" rx="1.5" />
      <path d="M7 17h6M10 14.5V17" />
      <path class="theme-auto-spark" d="m10 6 .55 1.45L12 8l-1.45.55L10 10l-.55-1.45L8 8l1.45-.55Z" />
    </svg>
  );
}

export function ThemePicker() {
  const [theme, setTheme] = useState<ThemePreference>(() => {
    const initial = storedTheme();
    applyTheme(initial);
    return initial;
  });

  useEffect(() => {
    applyTheme(theme);
    saveTheme(theme);
    if (theme !== "auto") return;

    const query = systemThemeQuery();
    const followSystem = () => applyTheme("auto");
    query.addEventListener("change", followSystem);
    return () => query.removeEventListener("change", followSystem);
  }, [theme]);

  return (
    <div class="theme-picker" role="group" aria-label="Appearance">
      {themes.map(({ label, value }) => (
        <button
          key={value}
          class={`theme-option${theme === value ? " is-active" : ""}`}
          type="button"
          title={label}
          aria-label={label}
          aria-pressed={theme === value}
          onClick={() => setTheme(value)}
        >
          <ThemeIcon theme={value} />
        </button>
      ))}
    </div>
  );
}
